import { FC, ReactNode } from 'react';
import { Col, Row, Skeleton } from 'antd';
import SearchUrlStatusModule from './status';
import SearchUrlUpdateModule from './update';
import { SearchUrlType } from '@copilot/common/utils/constant';
import { MultipleInvite } from '@copilot/data/responses/interface';

interface SearchUrlModuleProps {
	searchType: SearchUrlType;
	numPeople?: number;
	updateDate?: string;
	url?: string;
	isInitialSearch: boolean;
	isLoading?: boolean;
	searchPercentage?: number;
	showVideoLink: boolean;
	saveAndSearchButton: (searchUrl: string) => JSX.Element;
	onVideoLinkClicked: () => void;
	saveDisableWarning?: ReactNode;
	multipleInvite?: MultipleInvite;
	updateMultipleInvite?: (multipleInvite: MultipleInvite) => void;
	searchingText?: string;
}

//TODO Delete https://cassia.atlassian.net/browse/COPILOT-8286
const SearchUrlModule: FC<SearchUrlModuleProps> = (props) => {
	const {
		searchType,
		numPeople = 0,
		updateDate,
		url,
		isInitialSearch,
		searchPercentage,
		showVideoLink,
		saveAndSearchButton,
		onVideoLinkClicked,
		saveDisableWarning,
		isLoading,
		multipleInvite,
		updateMultipleInvite,
		searchingText,
	} = props;

	return (
		<Skeleton loading={!!isLoading}>
			<Row gutter={[0, 20]}>
				<Col span={24}>
					<SearchUrlStatusModule
						searchType={searchType}
						isInitialSearch={isInitialSearch}
						numPeople={numPeople}
						updateDate={updateDate}
						url={url}
					/>
				</Col>
				<Col span={24}>
					<SearchUrlUpdateModule
						searchType={searchType}
						isInitialSearch={isInitialSearch}
						searchPercentage={searchPercentage}
						searchingText={searchingText}
						showVideoLink={showVideoLink}
						saveAndSearchButton={saveAndSearchButton}
						onVideoLinkClicked={onVideoLinkClicked}
						saveDisableWarning={saveDisableWarning}
						multipleInvite={multipleInvite}
						updateMultipleInvite={updateMultipleInvite}
					/>
				</Col>
			</Row>
		</Skeleton>
	);
};

export default SearchUrlModule;
